import { 
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
  increment,
  arrayUnion,
  arrayRemove
} from 'firebase/firestore';
import { db } from '../firebase';
import { sendNewReviewToAdmin } from './emailService';

// ⚙️ AYARLAR
const ADMIN_EMAIL = 'info@tronapazarlama.com'; // 🔧 Buraya kendi admin mailinizi yazın

// ==================== KOLEKSİYON ====================
const reviewsCollection = collection(db, 'Reviews');

// ==================== DEĞERLENDİRME SİSTEMİ ====================

/**
 * Ürün değerlendirmesi ekle
 * ✅ MAİL ENTEGRASYONU EKLENDİ
 */
export const addProductReview = async (reviewData) => {
  try {
    // Daha önce değerlendirme yapılmış mı kontrol et
    const existingReviewQuery = query(
      reviewsCollection,
      where('userId', '==', reviewData.userId),
      where('productId', '==', reviewData.productId)
    );
    
    const existingReviews = await getDocs(existingReviewQuery);
    
    if (!existingReviews.empty) {
      return { 
        success: false, 
        error: 'Bu ürün için zaten değerlendirme yaptınız. Değerlendirmenizi düzenleyebilirsiniz.' 
      };
    }
    
    // Sipariş kontrolü
    if (reviewData.orderId) {
      const orderRef = doc(db, 'Orders', reviewData.orderId);
      const orderDoc = await getDoc(orderRef);
      
      if (!orderDoc.exists()) {
        return { success: false, error: 'Sipariş bulunamadı' };
      }
      
      const order = orderDoc.data();
      
      if (order.status !== 'delivered') {
        return { 
          success: false, 
          error: 'Sadece teslim edilmiş siparişlerdeki ürünleri değerlendirebilirsiniz.' 
        };
      }
      
      const productInOrder = order.items.some(item => item.productId === reviewData.productId);
      if (!productInOrder) {
        return { success: false, error: 'Bu ürünü satın almadınız.' };
      }
    }
    
    const review = {
      userId: reviewData.userId,
      userName: reviewData.userName || 'Anonim',
      productId: reviewData.productId,
      productName: reviewData.productName,
      orderId: reviewData.orderId || null,
      rating: reviewData.rating,
      title: reviewData.title || '',
      comment: reviewData.comment,
      images: reviewData.images || [],
      isVerifiedPurchase: !!reviewData.orderId,
      helpfulCount: 0,
      helpfulUsers: [],
      reportCount: 0,
      status: 'active', // ✅ Direkt aktif olarak ekle
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    const docRef = await addDoc(reviewsCollection, review);
    
    await updateProductRating(reviewData.productId);
    
    if (reviewData.orderId) {
      const orderRef = doc(db, 'Orders', reviewData.orderId);
      await updateDoc(orderRef, {
        [`reviewedProducts.${reviewData.productId}`]: true,
        updatedAt: serverTimestamp()
      });
    }
    
    // ✅ ADMİN'E YORUM BİLDİRİMİ GÖNDER
    try {
      await sendNewReviewToAdmin({
        productName: reviewData.productName,
        userName: reviewData.userName || 'Anonim',
        rating: reviewData.rating,
        comment: reviewData.comment,
        isVerifiedPurchase: !!reviewData.orderId
      }, ADMIN_EMAIL);
      console.log('✅ Admin\'e yeni değerlendirme bildirimi gönderildi');
    } catch (mailError) {
      console.error('❌ Değerlendirme maili gönderilemedi:', mailError);
    }
    
    return { 
      success: true, 
      reviewId: docRef.id,
      message: 'Değerlendirmeniz başarıyla eklendi. Teşekkür ederiz!' 
    };
  } catch (error) {
    console.error('Değerlendirme eklenemedi:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Ürün değerlendirmelerini getir
 */
export const getProductReviews = async (productId, filters = {}) => {
  try {
    console.log('🔍 getProductReviews çağrıldı:', productId);
    
    let q = query(
      reviewsCollection,
      where('productId', '==', productId)
    );
    
    if (filters.rating) {
      q = query(q, where('rating', '==', parseInt(filters.rating)));
    }
    
    if (filters.verifiedOnly) {
      q = query(q, where('isVerifiedPurchase', '==', true));
    }
    
    q = query(q, orderBy('createdAt', 'desc'));
    
    if (filters.limit) {
      q = query(q, limit(parseInt(filters.limit)));
    }
    
    const snapshot = await getDocs(q);
    console.log('📊 Toplam döküman:', snapshot.size);
    
    const allReviews = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate?.() || data.createdAt
      };
    });
    
    const activeReviews = allReviews.filter(review => 
      review.status === 'active' || !review.status
    );
    
    console.log('✅ Aktif yorumlar:', activeReviews.length);
    
    return { success: true, reviews: activeReviews };
  } catch (error) {
    console.error('❌ Değerlendirmeler alınamadı:', error);
    return { success: false, error: error.message, reviews: [] };
  }
};

/**
 * Kullanıcının değerlendirmelerini getir
 */
export const getUserReviews = async (userId) => {
  try {
    const q = query(
      reviewsCollection,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );
    
    const snapshot = await getDocs(q);
    const reviews = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate?.() || data.createdAt
      };
    });
    
    return { success: true, reviews };
  } catch (error) {
    console.error('Kullanıcı değerlendirmeleri alınamadı:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeyi güncelle
 */
export const updateReview = async (reviewId, userId, updateData) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    const review = reviewDoc.data();
    
    if (review.userId !== userId) {
      return { success: false, error: 'Bu değerlendirmeyi güncelleme yetkiniz yok' };
    }
    
    await updateDoc(reviewRef, {
      ...updateData,
      updatedAt: serverTimestamp()
    });
    
    if (updateData.rating && updateData.rating !== review.rating) {
      await updateProductRating(review.productId);
    }
    
    return { success: true, message: 'Değerlendirme güncellendi' };
  } catch (error) {
    console.error('Değerlendirme güncellenemedi:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeyi sil
 */
export const deleteReview = async (reviewId, userId) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    const review = reviewDoc.data();
    
    if (review.userId !== userId) {
      return { success: false, error: 'Bu değerlendirmeyi silme yetkiniz yok' };
    }
    
    const productId = review.productId;
    
    await deleteDoc(reviewRef);
    await updateProductRating(productId);
    
    return { success: true, message: 'Değerlendirme silindi' };
  } catch (error) {
    console.error('Değerlendirme silinemedi:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeye faydalı işareti ekle/kaldır
 */
export const toggleReviewHelpful = async (reviewId, userId) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    const review = reviewDoc.data();
    const helpfulUsers = review.helpfulUsers || [];
    
    if (helpfulUsers.includes(userId)) {
      await updateDoc(reviewRef, {
        helpfulCount: increment(-1),
        helpfulUsers: arrayRemove(userId)
      });
    } else {
      await updateDoc(reviewRef, {
        helpfulCount: increment(1),
        helpfulUsers: arrayUnion(userId)
      });
    }
    
    return { success: true };
  } catch (error) {
    console.error('İşlem yapılamadı:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Tüm değerlendirmeleri getir (Admin)
 */
export const getAllReviewsForAdmin = async () => {
  try {
    const q = query(reviewsCollection, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    
    const reviews = [];
    
    snapshot.forEach((doc) => {
      const data = doc.data();
      reviews.push({
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt
      });
    });
    
    return { success: true, reviews };
  } catch (error) {
    console.error('Değerlendirmeler alınamadı:', error);
    return { success: false, error: error.message, reviews: [] };
  }
};

/**
 * Değerlendirmeyi onayla (Admin)
 */
export const approveReview = async (reviewId) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    await updateDoc(reviewRef, {
      status: 'active',
      approvedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    const review = reviewDoc.data();
    await updateProductRating(review.productId);
    
    return { success: true, message: 'Değerlendirme onaylandı' };
  } catch (error) {
    console.error('Onaylama hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeyi reddet (Admin)
 */
export const rejectReview = async (reviewId, reason) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    await updateDoc(reviewRef, {
      status: 'rejected',
      rejectionReason: reason || 'Admin tarafından reddedildi',
      rejectedAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    const review = reviewDoc.data();
    await updateProductRating(review.productId);
    
    return { success: true, message: 'Değerlendirme reddedildi' };
  } catch (error) {
    console.error('Reddetme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeye yanıt ver (Admin)
 */
export const replyToReview = async (reviewId, message) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    await updateDoc(reviewRef, {
      adminReply: {
        message: message,
        adminName: 'Mağaza Yöneticisi',
        adminId: 'admin',
        createdAt: serverTimestamp()
      },
      updatedAt: serverTimestamp()
    });
    
    return { success: true, message: 'Yanıt başarıyla eklendi' };
  } catch (error) {
    console.error('Yanıt ekleme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Değerlendirmeyi sil (Admin)
 */
export const deleteReviewAdmin = async (reviewId) => {
  try {
    const reviewRef = doc(db, 'Reviews', reviewId);
    const reviewDoc = await getDoc(reviewRef);
    
    if (!reviewDoc.exists()) {
      return { success: false, error: 'Değerlendirme bulunamadı' };
    }
    
    const review = reviewDoc.data();
    const productId = review.productId;
    
    await deleteDoc(reviewRef);
    await updateProductRating(productId);
    
    return { success: true, message: 'Değerlendirme silindi' };
  } catch (error) {
    console.error('Silme hatası:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Ürünün ortalama puanını güncelle
 */
const updateProductRating = async (productId) => {
  try {
    const q = query(
      reviewsCollection,
      where('productId', '==', productId)
    );
    
    const snapshot = await getDocs(q);
    
    const activeReviews = snapshot.docs
      .map(doc => doc.data())
      .filter(review => review.status === 'active' || !review.status);
    
    if (activeReviews.length === 0) {
      await updateDoc(doc(db, 'Products', productId), {
        rating: 0,
        reviewCount: 0,
        ratingDistribution: {
          5: 0,
          4: 0,
          3: 0,
          2: 0,
          1: 0
        }
      });
      return;
    }
    
    const totalRating = activeReviews.reduce((sum, r) => sum + r.rating, 0);
    const avgRating = totalRating / activeReviews.length;
    
    const distribution = {
      5: activeReviews.filter(r => r.rating === 5).length,
      4: activeReviews.filter(r => r.rating === 4).length,
      3: activeReviews.filter(r => r.rating === 3).length,
      2: activeReviews.filter(r => r.rating === 2).length,
      1: activeReviews.filter(r => r.rating === 1).length
    };
    
    await updateDoc(doc(db, 'Products', productId), {
      rating: parseFloat(avgRating.toFixed(1)),
      reviewCount: activeReviews.length,
      ratingDistribution: distribution
    });
  } catch (error) {
    console.error('Ürün rating güncellenemedi:', error);
  }
};

export default {
  addProductReview,
  getProductReviews,
  getUserReviews,
  updateReview,
  deleteReview,
  toggleReviewHelpful,
  getAllReviewsForAdmin,
  approveReview,
  rejectReview,
  replyToReview,
  deleteReviewAdmin
};